import { useState, React } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroupItem,
  Alert,
} from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { ZeroOneKLessons } from "../modules/ZeroOneKLessons";
import { OneTwoKLessons } from "../modules/OneTwoKLessons";
import { TwoThreeKLessons } from "../modules/TwoThreeKLessons";
import { ThreeFourKLessons } from "../modules/ThreeFourKLessons";
import { FourFiveKLessons } from "../modules/FourFiveKLessons";
import { FiveSixKLessons } from "../modules/FiveSixKLessons";
import { Link } from "react-router-dom";
import { News1 } from "../modules/News1";

export default function HomePage() {
  const [selectedWord, setSelectedWord] = useState("");

  const vocab = {
    1: { koreanWord: "참다", engTranslation: "to endure, to hold back" },
    13: { koreanWord: "깊숙이", engTranslation: "deeply, far inside" },
    46: { koreanWord: "주관적", engTranslation: "subjective" },
  };

  function action(i) {
    const koreanWord = vocab[i].koreanWord;
    const english = vocab[i].engTranslation;

    setSelectedWord({
      korean: koreanWord,
      english: english,
    });
  }

  function countObjects(arr) {
    return arr.filter(
      (item) =>
        typeof item === "object" && item !== null && !Array.isArray(item)
    ).length;
  }

  const numberOfWords01 = countObjects(ZeroOneKLessons) * 50;
  const numberOfWords12 = countObjects(OneTwoKLessons) * 50;
  const numberOfWords23 = countObjects(TwoThreeKLessons) * 50;
  const numberOfWords34 = countObjects(ThreeFourKLessons) * 50;
  const numberOfWords45 = countObjects(FourFiveKLessons) * 50;
  const numberOfWords56 = countObjects(FiveSixKLessons) * 50;
  const numberOfWordsNews = countObjects(News1) * 50;

  const totalWords =
    numberOfWords01 +
    numberOfWords12 +
    numberOfWords23 +
    numberOfWords34 +
    numberOfWords45 +
    numberOfWords56 +
    numberOfWordsNews;
  return (
    <Container>
      <Row className="my-4">
        <Col>
          <h1 className="fs-4 text-center text-primary">
            Learn Korean vocabulary
          </h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="mb-4">
            <Card.Body className="py-4 mx-auto text-center">
              <h5 className="card-title text-primary">
                Learning new vocabulary is hard
              </h5>
              <h6 className="card-subtitle my-3 text-muted">
                Word lists can be difficult and boring
              </h6>
              <Button
                variant="outline-secondary"
                size="lg"
                className="me-1"
                onClick={() => action(13)}
              >
                깊숙이
              </Button>
              <Button
                variant="outline-secondary"
                size="lg"
                className="me-1"
                onClick={() => action(1)}
              >
                참다
              </Button>
              <Button
                variant="outline-secondary"
                size="lg"
                onClick={() => action(46)}
              >
                주관적
              </Button>
              <p className="text-muted">(Click on the words to translate)</p>
            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Body className="py-4 mx-auto text-center">
              <h5 className="card-title text-primary">
                Why not give yourself a hint?
              </h5>
              <h6 className="card-subtitle mt-3 mb-2 text-muted">
                Context is the hint that helps you to recall words you can't
                quite remember
              </h6>
              <h6 className="card-subtitle mb-3 text-muted">
                It also makes learning more interesting
              </h6>

              <p className="border p-3 border-primary">
                If you travel
                <Button
                  variant="outline-secondary"
                  size="lg"
                  className="mx-2"
                  onClick={() => action(13)}
                >
                  깊숙이
                </Button>
                into the forest.
              </p>
              <p className="border p-3 border-primary">
                I was trying to
                <Button
                  variant="outline-secondary"
                  size="lg"
                  className="mx-2"
                  onClick={() => action(1)}
                >
                  참다
                </Button>
                my hunger.
              </p>
              <p className="border p-3 border-primary">
                She knows that everyone has their own
                <Button
                  variant="outline-secondary"
                  size="lg"
                  className="mx-2"
                  onClick={() => action(46)}
                >
                  주관적
                </Button>
                idea of a good holiday.
              </p>
              <h6 className="card-subtitle mb-2 text-muted">
                It might seem like cheating but it's just what your brain needs
              </h6>
            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Body className="py-4 mx-auto text-center">
              <h5 className="card-title text-primary">
                Context in English, not Korean
              </h5>
              <h6 className="card-subtitle mt-3 mb-2 text-muted">
                Easier, less stressful, less tiring, more sustainable
              </h6>
              <h6 className="card-subtitle mb-2 text-muted">
                Don't stress yourself reading Korean you already know
              </h6>
              <h6 className="card-subtitle mb-2 text-muted">
                Focus on Korean words you don't know
              </h6>
              <h6 className="card-subtitle mb-2 text-muted">
                Quicker to repeat and review
              </h6>
              <h6 className="card-subtitle mb-2 text-muted">
                Learn new words fast then move on and practice Korean with
                <p className="ms-1 fw-bold d-inline">
                  things you're actually interested in
                </p>
              </h6>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body className="py-4 mx-auto text-center">
              <h5 className="card-title text-primary">Try a lesson now</h5>
              <h6 className="card-subtitle mt-3 mb-2 text-muted">
                Lessons are divided by word frequency
              </h6>
              <h6 className="card-subtitle mb-3 text-muted">
                Each lesson has 50 words in a short story
              </h6>
              <Link
                to="/34klesson1"
                className="text-decoration-none text-secondary d-inline"
              >
                <Button>Lesson: Exploring a traditional Korean village</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className=" mt-5">
        <Col>
          <div className="alert alert-light py-1 fw-bold" role="alert">
            Lesson Index
            <span className="ms-3 text-secondary fst-italic">
              (Current total: ~{totalWords} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="alert alert-success py-1" role="alert">
            Word frequency 0-1000{" "}
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords01} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {ZeroOneKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/01klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-info py-1" role="alert">
            Word frequency 1000-2000
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords12} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {OneTwoKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/12klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-primary py-1" role="alert">
            Word frequency 2000-3000
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords23} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {TwoThreeKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/23klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-secondary py-1" role="alert">
            Word frequency 3000-4000
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords34} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {ThreeFourKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/34klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-warning py-1" role="alert">
            Word frequency 4000-5000
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords45} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {FourFiveKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/45klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-danger py-1" role="alert">
            Word frequency 5000-6000
            <span className="ms-3 text-secondary fst-italic">
              ({numberOfWords56} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {FiveSixKLessons.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/56klesson${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <div className="alert alert-dark py-1" role="alert">
            News vocabulary
            <span className="ms-3 text-secondary fst-italic">
              (~{numberOfWordsNews} words)
            </span>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ListGroup as="ol" numbered>
            {News1.map((item) => (
              <ListGroup.Item
                key={item.lessonNumber}
                className="text-secondary"
              >
                <Link
                  to={`/NewsVocabulary${item.lessonNumber}`}
                  className="text-decoration-none text-secondary d-inline"
                >
                  {item.lessonTitle}
                </Link>
              </ListGroup.Item>
            ))}
            <ListGroupItem className="text-secondary">
              Coming soon...
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col>
          <div className="alert alert-light" role="alert">
            Based on a word list published by the National Institute of Korean
            Language, Republic of Korea. The original word list can be found
            <a
              href="https://www.korean.go.kr/front/etcData/etcDataView.do?mn_id=46&etc_seq=71"
              className="alert-link ms-1"
            >
              here
            </a>
            .
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Alert variant="light">
            <Alert.Heading>Announcements</Alert.Heading>
            <ul>
              <li>
                <p>
                  If you find problems or want to give feedback you can use this
                  Reddit post
                  <Alert.Link
                    href="https://www.reddit.com/r/Korean/comments/1p24beg/learn_korean_vocabulary_with_hint_%ED%9E%8C%ED%8A%B8_korean/"
                    className="ms-1"
                  >
                    here
                  </Alert.Link>
                  , or send me a message, my Reddit ID is: Comfortable-Owl4902
                </p>
              </li>
              <li>
                <p>I'm trying to add at least one new lesson a day.</p>
              </li>
            </ul>
          </Alert>
        </Col>
      </Row>

      <Row className="my-5"></Row>
      <Row className="my-5"></Row>
      <Row className="my-5"></Row>

      <Container className="bg-white fixed-bottom border py-3">
        <Row>
          <Col>
            <div className="d-flex align-items-center mb-1">
              <p className="mb-0 me-2 fs-4 fw-lighter bg-danger bg-opacity-10 px-3 rounded">
                Korean:
              </p>
              <p className="mb-0 fs-4">{selectedWord.korean}</p>
            </div>
            <div className="d-flex align-items-center">
              <p className="mb-0 me-2 fs-4 fw-lighter bg-info bg-opacity-10 px-3 rounded">
                English:
              </p>
              <p className="mb-0 fs-4">{selectedWord.english}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
